import React, { useEffect } from "react"
// import Image from "next/image"
// import imgTop from "assets/img/image/img_about-top.png"
import imgTop from "assets/img/image/img_about-mission-statement.png"

//Utils
import { useRouter } from "next/router"
import {
  useIsomorphicLayoutEffect,
  useScrollAnim,
} from "@components/hooks/hooks"
import { Breadcrumb, Image } from "@components/anti"

const AboutComp = ({ locale, locales }) => {
  //Utils
  const Router = useRouter()

  const [trigger, anim] = useScrollAnim()

  // useIsomorphicLayoutEffect(() => {
  //   document.documentElement.classList.add("enable-sticky")
  // }, [])
  //React Operations ******************************************************************** //

  return (
    <section className={`sc-mission-statement`} ref={trigger}>
      <div className="container">
        <Breadcrumb path={`/About`} className="d-none d-sm-flex" />
        <div className="btn-back-wrapper">
          <span
            className="ail ai-arrow-left font-weight-bold"
            style={{ cursor: "pointer" }}
            onClick={() => Router.back()}
          />
        </div>
        <div className={`row align-items-center`}>
          <div className="col-12 col-md-6 offset-md-1 order-md-2 mb-3 mb-md-0">
            <Image
              src={imgTop}
              alt="about-top"
              placeholder="blur"
              className="img-top-about fadeInUp d2"
              ratio="r-1-1"
            />
          </div>
          <div className="col-12 col-md-4 offset-md-1 wrapper-content order-md-1">
            <h1 className={`title ${anim(2)}`}>Mission Statement</h1>
            <h6 className={`text ${anim(3)}`}>
              Creation of a good living & beautiful spaces is our core value.
              Based on everyday simplicity and functionality, we create an
              affordable, fine craftmanship, & naturally sourced products.
            </h6>
            <h6 className={`text ${anim(4)}`}>
              Every single products are rooted in appreciation: raw materials,
              the space & the user, the artisan who made it & the designers who
              designed it.
            </h6>
            <h6 className={`text ${anim(5)}`}>
              Furthermore, we take pride in exploring unconventional natural
              materials and turn it into a beautiful furnishing and pieces.
            </h6>
          </div>
        </div>
      </div>
    </section>
  )
}

export default AboutComp
